import { z } from "zod";
import { MetaSchema } from "./shared";
import { UserConnectWallet } from ".";

const postAuthIdentityWalletVerify = z.object({
  data: UserConnectWallet.ConnectWalletDataSchema,
  meta: MetaSchema.default,
});

export default postAuthIdentityWalletVerify;
